import axios from "axios";

const searchStates = {
  in_progress: true,
  succeeded: false,
  cancelled: false,
  idle: "empty",
};

const getDefaultState = () => {
  return {
    active: false,
    results: null,
    timestamp: null,
    loadingResults: searchStates.idle,
    cancelSearch: null,
    results_primary: [],
    results_secondary: [],
    results_text_only: [],
    preview_primary: [],
    preview_secondary: [],
    preview_text_only: [],
  };
};
const state = getDefaultState;

const getters = {
  searchInProgress (state) {
    return !!state.cancelSearch;
  },
  getSearchResult: (state) => {
    return state.results;
  },
  getSearchTimestamp: (state) => {
    return state.timestamp;
  },
  getResultsPrimary: (state) => {
    return state.results_primary;
  },
  getResultsSecondary: (state) => {
    return state.results_secondary;
  },
  getResultsTestOnly: (state) => {
    return state.results_text_only;
  },
  getPrimaryPreviews: (state) => {
    return state.preview_primary;
  },
  getSecondaryPreviews: (state) => {
    return state.preview_secondary;
  },
  getTextOnlyPreviews: (state) => {
    return state.preview_text_only;
  },
  getSearchState: (state) => {
    return state.active;
  },
  getSearchLoadStatus: (state) => {
    return state.loadingResults;
  },
};

function updateStatus (state, msg) {
  state.loadingResults = msg;
}

const mutations = {
  addRequest (state, payload) {
    state.results = [];
    state.cancelSearch = payload;
    updateStatus(state, searchStates.in_progress);
  },
  cancelRequest (state) {
    if (state.cancelSearch) {
      state.cancelSearch();
    }
    state.cancelSearch = null;
    updateStatus(state, searchStates.cancelled);
  },

  resetSearchState(state) {
    Object.assign(state, getDefaultState());
  },
  setSearchLoadStatus: (state, payload) => {
    state.loadingResults = payload;
  },
  setSearchState: (state, payload) => {
    state.active = payload;
  },
  setSearchResults: (state, payload) => {
    state.results = payload;
    let items = {};
    const catKeys = Object.keys(payload);
    catKeys.forEach((category) => {
      items[category] = [];
      for (let i = 0; i < payload[category].length; i++) {
        for (let j = 0; j < payload[category][i]["posts"].length; j++) {
          const post = payload[category][i]["posts"][j];
          items[category].push(post.base_id);
        }
      }
    });

    catKeys.forEach((category) => {
      state["results_" + category] = [... new Set(items[category])];
    });
    updateStatus(state, searchStates.succeeded);
  },
  setTimestamps: (state, payload) => {
    state.timestamp = payload;
  },
  setSearchPreviews(state, previewCategories) {
    let cats = Object.keys(previewCategories);
    for (let i = 0; i < cats.length; i++) {
      this.commit("addSearchPreview", {
        category: cats[i],
        items: previewCategories[cats[i]],
      });
    }
  },
  addSearchPreview: (state, payload) => {
    state["preview_" + payload.category] = state[
      "preview_" + payload.category
    ].concat(payload.items);
  },
};

const actions = {
  async searchItems({ commit }, searchData) {
    commit("cancelRequest");
    commit("resetSearchState");
    const source = axios.CancelToken.source();
    commit("addRequest", source.cancel);
    commit("setSearchState", true);
    updateStatus(state, searchStates.in_progress);
    let { data } = await axios.get("search", { params: searchData, cancelToken: source.token });
    commit("setSearchResults", data.data);
    commit("setTimestamps", data.time);
    commit("setSearchPreviews", data.previews);
    },
  clearSearch({ commit }) {
    commit("setSearchState", false);
  },
  async addSearchPreview({ commit }, requestData) {
    const baseIds = this.state.search["results_" + requestData.category].slice(
      this.state.search["preview_" + requestData.category].length,
      this.state.search["preview_" + requestData.category].length + 3
    );
    let params = {
      ids: baseIds,
    };
    if (requestData.query) {
      params["query"] = requestData.query;
    }
    let { data } = await axios.get("search-previews", {
      params: params,
    });
    commit("addSearchPreview", {
      category: requestData.category,
      items: data.data,
    });
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
